
        require('./index.scss');
        "use strict";;
    


// WEBPACK FOOTER //
// ./src/module/home-detail/cross-ad/index.js